// extracted by mini-css-extract-plugin
module.exports = {"root":"l_b","dividerAnimation":"l_p"};